/*
 * @Author: qh_feng
 * @Date: 2022-03-17 17:22:49
 * @LastEditTime: 2023-02-04 16:48:57
 * @LastEditors: your name
 * @Description: 
 * @ FilePath: Do not edit
 * @par 修改日志:
 * 内容:  查询检索 API
 */
export default {
  //人脸数据检索
  POST_facePage: '/dqi-hymanage/face/page',
  //车辆数据检索(闸机、卡口)
  POST_motorvehiclePage: '/dqi-hymanage/motorvehicle/page',
  //地图轨迹
  POST_track: '/dqi-hymanage/motorvehicle/getTrack',
  // 首页一次获取所有接口信息
  GET_getAllResource: '/dqi-hymanage/index/getAllResource'
}


// WEBPACK FOOTER //
// ./src/http/apiModules/search.js